module.exports = __webpack_public_path__ + "images/dingtalk/init-stars-10ea36ef1f70247a9e28f049ed1d8cd5.png";